import { Injectable } from "@angular/core";

import { BeneficiaryRepository } from "../../repositories/pbm/beneficiary.repository";
import { BeneficiaryDTO } from "../../models/domains/pbm/Beneficiary/dto/beneficiary-dto";
import { BeneficiarySearchParameterDTO } from "../../models/domains/pbm/Beneficiary/dto/beneficiary-search-parameter-dto";
import { LoadingService } from "../loading.service";
import { Toast } from "../../components/toast/toast";
import { CardState, ExportType } from "../../models/domains/pbm/Beneficiary/interfaces/IFilterBeneficiarySearchParameterByExport";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";

@Injectable({ providedIn: "root" })
export class ExportBeneficiariesService {
    /**
     * 0=status inicial
     * 1=processando
     * 2=processado e pronto para download
     */
    private processStatus: number = 0;
    private beneficiries = new MatTableDataSource<BeneficiaryDTO>();
    private selectedBeneficiaries = new SelectionModel<BeneficiaryDTO>(true, []);
    filters = new UntypedFormGroup({
        cardState: new UntypedFormControl([CardState.Active], [Validators.required]),
        typeExport: new UntypedFormControl(ExportType.All, [Validators.required]),
        startDate: new UntypedFormControl('', [Validators.required]),
        endDate: new UntypedFormControl('', [Validators.required]),
        linhas: new UntypedFormControl('1', [Validators.required]),
        format: new UntypedFormControl('xlsx', [Validators.required]),
        totalPerPage: new UntypedFormControl(100, [Validators.required]),
    });
    private resultsLength = 0;

    constructor(
        private beneficiaryRepository: BeneficiaryRepository,
        private loadingService: LoadingService,
        private toast: Toast
    ) { }

    /**
     *
     * @returns 0=status inicial | 1=processando | 2=processado e pronto para download
     */
    getProcessStatus(): number {
        return this.processStatus;
    }

    setProcessStatus(processStatus: 0 | 1 | 2) {
        this.processStatus = processStatus;
    }

    getBeneficiries() {
        return this.beneficiries;
    }

    getSelectedBeneficiaries() {
        return this.selectedBeneficiaries;
    }

    getFilters() {
        return this.filters;
    }

    getResultLenght() {
        return this.resultsLength;
    }

    async searchbeneficiries(params: BeneficiarySearchParameterDTO) {
        return await this.beneficiaryRepository.SearchBeneficiaries(params)
            .then((beneficiariesByExport) => {
                const beneficiaries = beneficiariesByExport

                if (beneficiaries.Data.length === 0)
                    this.toast.showWarningToast("Nenhum beneficiários/dependentes encontrado com os filtros informado(s).", "Atenção!");

                return beneficiaries.Data;
            }).catch((error) => {
                console.error(error)
                this.toast.showWarningToast(error, "Atenção");
                return [];
            })
    }

    async filterbeneficiries(params: BeneficiarySearchParameterDTO) {
        const ref = this.loadingService.beginLoading();
        await this.beneficiaryRepository.SearchBeneficiaries(params)
            .then((beneficiariesByExport) => {
                const beneficiaries = beneficiariesByExport

                if (beneficiaries.Data.length === 0)
                    this.toast.showWarningToast("Nenhum beneficiários/dependentes encontrado com os filtros informado(s).", "Atenção!");

                this.beneficiries.data = beneficiaries.Data
                this.resultsLength = beneficiaries.Count
            }).catch((error) => {
                console.error(error)
                this.toast.showWarningToast(error, "Atenção")
            }).finally(() => {
                this.loadingService.finishLoading(ref);
            })
    }

    isAllSelected() {
        const numSelected = this.selectedBeneficiaries.selected.length;
        const numRows = this.beneficiries.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        if (this.isAllSelected()) {
            this.selectedBeneficiaries.clear();
            return;
        }
        this.selectedBeneficiaries.clear();
        this.beneficiries.data.forEach((element) => {
            this.selectedBeneficiaries.selected.push(element);
        });
        this.getFilters().get('linhas').setValue("0")
    }

    selectBeneficiary(event: any, beneficiary: BeneficiaryDTO) {
        const idx = this.getIsSelected(beneficiary);
        if (idx == -1) {
            this.getFilters().get('linhas').setValue("0")
            this.selectedBeneficiaries.selected.push(beneficiary);
        } else {
            this.selectedBeneficiaries.selected.splice(idx, 1);
        }

        if (this.selectedBeneficiaries.selected.length === 0)
            this.getFilters().get('linhas').setValue("")
    }

    getIsSelected(beneficiary: BeneficiaryDTO): number {
        let ret = -1;
        for (let i = 0; i < this.selectedBeneficiaries.selected.length; i++) {
            const selected = this.selectedBeneficiaries.selected[i];
            if (beneficiary.Id === selected.Id) {
                ret = i;
                break;
            }
        }
        return ret;
    }

    clearFields() {
        this.filters = new UntypedFormGroup({
            cardState: new UntypedFormControl([CardState.Active], [Validators.required]),
            typeExport: new UntypedFormControl(ExportType.All, [Validators.required]),
            startDate: new UntypedFormControl('', [Validators.required]),
            endDate: new UntypedFormControl('', [Validators.required]),
            linhas: new UntypedFormControl('1', [Validators.required]),
            format: new UntypedFormControl('xlsx', [Validators.required]),
            totalPerPage: new UntypedFormControl(100, [Validators.required]),
        });
        this.beneficiries.data = [];
    }
}